import { ICompanyLeadSettings } from "@raskrask-dk/raskrask-utils";
import type CompanyLeadState from "..";
import {Action} from "../../../action/action";


/**
 * This action lets the user submit for long form, where they can pick a lot of settings.
 * These settings has default values and most of them are not obligatory.
 */
export class SetCompanySettings extends Action<"SET_COMPANY_SETTINGS", ICompanyLeadSettings> {
  readonly type = "SET_COMPANY_SETTINGS";
  protected state: CompanyLeadState;

  constructor(state: CompanyLeadState, data?: ICompanyLeadSettings) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    return this.isDoable();
  }

  /**
   *
   * @returns whether the user can settings.
   *
   * Business logic:
   * If the user is on the companystate and has chosen the "lead" option,
   * all they can do is to set the settings.
   */
  public isDoable = (): boolean => this.state.bookingflowStateMachine.getData().product.type === "CompanyLead";
}
